<div class="cap-container">
    <app-header></app-header> 
    <app-menubar></app-menubar>
    <router-outlet></router-outlet> 
</div>

